import BlockContent from '@sanity/block-content-to-react';
import EndOfPageCtaWithForm from 'components/generic/EndOfPageCTAwithForm';
import { Layout } from 'components/layout';
import Seo from 'components/seo';
import { YoutubeEmbed } from 'components/tsxCommon/YoutubeEmbed';
import {  graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import getYouTubeID from 'get-youtube-id';
import { getLocalizedContent } from 'helpers/Localization';
import React from 'react';
import { serializers } from 'components/tsxCommon/BlockContentSerializer';

const CustomerStory = (props) => {
    const {
        image,
        _rawDescription,
        companyName,
        customerStoryPerson,
        customerAndUs,
        _rawContent,
        industry
    } = props.data.sanityCustomerStory;

    let { vimeoLink } = props.data.sanityCustomerStory;

    let youtubeVideo = null;
    if (vimeoLink?.includes('youtube')) {
        youtubeVideo = getYouTubeID(vimeoLink);
        vimeoLink = '';
    }

    const getBlockContent = () => {
        const localizedBlockContent = getLocalizedContent(_rawContent);
        if (localizedBlockContent) {
            return (
                <div className="body">
                    <BlockContent
                        blocks={localizedBlockContent}
                        imageOptions={{ w: 720, fit: 'max' }}
                        projectId="ku7s4y42"
                        dataset="production"
                        serializers={serializers}
                    />
                </div>
            );
        }

        return null;
    };

    return (
        <div className="customerStory">
            <Seo
                title={`${companyName} | Customers | SalesScreen`}
                description={getLocalizedContent(customerAndUs)}
                img={image.asset.gatsbyImageData.images.fallback.src}
            />
            <Layout darkNav={true}>
                <div className="container">
                    <div className="lg:tw-prose-lg tw-prose tw-py-64 tw-mx-auto">
                        <h1 className="tw-my-32">{companyName}</h1>
                        <p className="tw-text-xl tw-text-neutral-subdued">
                            {getLocalizedContent(customerAndUs)}
                        </p>
                        {industry && industry.en && (
                            <div className="tw-flex tw-gap-12 tw-items-center tw-mb-12 tw-text-sm">
                                <p>Industry:</p>
                                <p className="tw-m-0 tw-rounded tw-border tw-border-primary tw-bg-neutral-variant-0 tw-border-dashed tw-inline-block tw-px-12 tw-py-4">
                                    {getLocalizedContent(industry)}
                                </p>
                            </div>
                        )}
                        {youtubeVideo ? (
                            <YoutubeEmbed
                                videoId={youtubeVideo}
                                classNames="tw-w-full tw-aspect-video"
                            />
                        ) : (
                            <GatsbyImage
                                image={image.asset.gatsbyImageData}
                                alt={companyName}
                                className="w-100"
                                imgStyle={{ objectFit: 'contain' }}
                            />
                        )}

                        <figure>
                            <blockquote>
                                <p>{getLocalizedContent(customerStoryPerson.quote)}</p>
                            </blockquote>
                            <figcaption>
                                —{customerStoryPerson.fullName}, {customerStoryPerson.title}
                            </figcaption>
                        </figure>
                        {_rawDescription && _rawDescription.en ? (
                            <div className="tw-py-12 tw-px-24 tw-bg-neutral-variant-1 tw-rounded tw-shadow-xs">
                                <BlockContent blocks={getLocalizedContent(_rawDescription)} />
                            </div>
                        ) : null}
                        {vimeoLink ? (
                            <iframe
                                className="tw-w-full tw-h-[400px] tw-my-48"
                                src={vimeoLink}
                                frameBorder="0"
                                title="Visma Mamut Customer Success Story"
                            />
                        ) : null}
                        <div className="tw-mt-64">{getBlockContent(_rawContent)}</div>
                    </div>
                </div>
                <EndOfPageCtaWithForm />
            </Layout>
        </div>
    );
};

export default CustomerStory;

export const query = graphql`
    query CustomerStory($companyName: String!) {
        sanityCustomerStory(companyName: { eq: $companyName }) {
            companyName
            industry {
                en
                nb
                nl
                se
            }
            _rawDescription
            customerAndUs {
                en
                nb
                nl
                se
            }
            _rawContent
            image {
                asset {
                    gatsbyImageData(width: 1200, placeholder: BLURRED)
                }
            }
            vimeoLink
            customerStoryPerson {
                fullName
                title
                quote {
                    en
                    nb
                    nl
                    se
                }
            }
        }
    }
`;
